class n extends HTMLElement{#e=[];#t=0;#i;#s=!1;#a=matchMedia("(width >= 960px)");connectedCallback(){this.#e=Array.from(this.querySelectorAll(".cl-testi__slide")),this.#t=Number(this.dataset.active??0),this.style.setProperty("--n",String(this.#e.length)),this.addEventListener("click",i=>{const e=i.target;if(!(e instanceof Element))return;const t=e.closest("[data-toggle]");if(t){const s=t.getAttribute("aria-pressed")!=="true";t.setAttribute("aria-pressed",String(s));const a=s?t.dataset.labelPlay:t.dataset.labelPause;a&&t.setAttribute("aria-label",a),this.#s=s,s?this.pause():this.play()}else if(e.closest("[data-next]"))this.go(this.#t+1,!0);else if(e.closest("[data-prev]"))this.go(this.#t-1,!0);else{const a=e.closest(".cl-testi__collapsed")?.closest(".cl-testi__slide");a&&this.go(Number(a.dataset.index),!0)}}),this.addEventListener("mouseenter",()=>this.pause()),this.addEventListener("mouseleave",()=>this.play()),this.addEventListener("focusin",()=>this.pause()),this.addEventListener("focusout",()=>this.play()),document.addEventListener("shopify:block:select",i=>{const e=i.target;if(!(e instanceof Element))return;const t=e.closest(".cl-testi__slide");t&&this.contains(t)&&this.go(Number(t.dataset.index),!0)}),this.play()}disconnectedCallback(){this.pause()}go(i,e=!1){const t=this.#e.length;if(t===0)return;this.#t=(i%t+t)%t,this.#e.forEach((a,l)=>a.classList.toggle("is-active",l===this.#t));const s=this.querySelector("[data-carousel-status]");s&&e&&(s.textContent=(this.dataset.statusTemplate??"").replace("%index%",String(this.#t+1))),e&&(this.#s=!0,this.pause())}play(){const i=matchMedia("(prefers-reduced-motion: reduce)").matches;this.#s||this.dataset.autoplay!=="true"||!this.#a.matches||i||(this.pause(),this.#i=window.setInterval(()=>this.go(this.#t+1),Number(this.dataset.interval??5e3)))}pause(){window.clearInterval(this.#i)}}customElements.get("cl-testimonials")||customElements.define("cl-testimonials",n);

(() => {
  const mobile = matchMedia('(width < 960px)');

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0 || !mobile.matches) return;
    const track = event.target.closest?.('cl-testimonials .cl-testi__track');
    if (!track || track.scrollWidth <= track.clientWidth) return;

    const startX = event.clientX;
    const startScroll = track.scrollLeft;
    let dragged = false;

    const move = (e) => {
      const dx = e.clientX - startX;
      if (!dragged && Math.abs(dx) < 5) return;
      if (!dragged) {
        dragged = true;
        track.classList.add('is-dragging');
      }
      track.scrollLeft = startScroll - dx;
    };

    const end = () => {
      document.removeEventListener('pointermove', move);
      document.removeEventListener('pointerup', end);
      document.removeEventListener('pointercancel', end);
      if (!dragged) return;
      track.classList.remove('is-dragging');
      const block = (e) => e.preventDefault();
      track.addEventListener('click', block, { capture: true, once: true });
      setTimeout(() => track.removeEventListener('click', block, true), 0);
    };

    document.addEventListener('pointermove', move);
    document.addEventListener('pointerup', end);
    document.addEventListener('pointercancel', end);
  });

  document.addEventListener('dragstart', (event) => {
    if (event.target.closest?.('cl-testimonials .cl-testi__track')) event.preventDefault();
  });
})();
